import { Button } from "components/UI/atoms";
import { Modal } from "components/UI/molecules";
import { useGetTermsContent } from "./utils/useGetTermsContent";
import "./index.scss";

export const TermsOfUseModal = ({ modalIsOpen, setModalIsOpen }) => {
  const { modalContent } = useGetTermsContent({ modalIsOpen });

  return (
    <div className="terms-of-use">
      <Modal
        header={<h3 className="modal-title">Terms of Use</h3>}
        isOpen={modalIsOpen}
        onBackdropClick={() => setModalIsOpen(false)}
        customClassName="terms-of-use-modal"
      >
        <p className="scroll-message">
          Please read the complete Terms of Use carefully before you agree.
        </p>
        {modalContent && (
          <div
            className="modal-terms-content"
            data-testid="modal-terms-content"
            dangerouslySetInnerHTML={{ __html: modalContent }}
          />
        )}
        <Button
          customClassName="close-button"
          onClick={() => setModalIsOpen(false)}
        >
          Close
        </Button>
      </Modal>
    </div>
  );
};
